import Reveal from "@/components/Reveal";

const MenuList = ({ items, side }) => (
  <ul data-testid={`menu-list-${side}`} className="space-y-10">
    {items.map((item, i) => (
      <li key={`${item.name}-${i}`} data-testid={`menu-item-${item.name}`}>
        <div className="flex items-baseline gap-3">
          <h4 className="font-serif text-xl md:text-2xl text-sm-text">{item.name}</h4>
          <span className="sm-leader" />
          <span className="font-serif text-base md:text-lg text-sm-olive whitespace-nowrap">
            {item.price}
          </span>
        </div>
        {item.desc && (
          <p className="mt-2 text-sm md:text-[15px] text-sm-muted leading-relaxed font-light max-w-xl">
            {item.desc}
          </p>
        )}
      </li>
    ))}
  </ul>
);

const CategoryBlock = ({ category, index }) => {
  const isReversed = index % 2 === 1;
  return (
    <div
      data-testid={`menu-category-${category.id}`}
      className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start"
    >
      <Reveal className={`lg:col-span-4 ${isReversed ? "lg:order-2" : "lg:order-1"}`}>
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={category.image_url}
            alt={category.title}
            className="w-full h-full object-cover transition-transform duration-[1800ms] hover:scale-[1.05]"
          />
          <div className="absolute top-4 left-4 bg-sm-bg/90 backdrop-blur-sm px-3 py-2 border border-sm-border">
            <p className="text-[0.6rem] tracking-[0.32em] uppercase text-sm-olive">
              · 0{index + 1}
            </p>
          </div>
        </div>
      </Reveal>

      <div className={`lg:col-span-8 ${isReversed ? "lg:order-1 lg:pr-8" : "lg:order-2 lg:pl-8"}`}>
        <Reveal>
          <p className="sm-eyebrow">{category.subtitle}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h3 className="font-serif text-4xl md:text-5xl lg:text-6xl text-sm-text mt-4 mb-10 italic font-light">
            {category.title}
          </h3>
        </Reveal>
        <Reveal delay={0.2}>
          <MenuList items={category.items || []} side={category.id} />
        </Reveal>
      </div>
    </div>
  );
};

export const Menu = ({ content }) => {
  const c = content || {};
  const categories = c.categories || [];

  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="relative bg-sm-surface py-24 md:py-36 sm-grain"
    >
      <div className="sm-container relative">
        <Reveal>
          <p className="sm-eyebrow text-center">{c.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2
            data-testid="menu-title"
            className="font-serif text-5xl md:text-6xl lg:text-7xl text-sm-text text-center mt-6 leading-[0.95] italic font-light"
          >
            {c.title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p
            data-testid="menu-disclaimer"
            className="text-center text-sm md:text-base text-sm-muted mt-8 max-w-xl mx-auto italic font-light"
          >
            {c.disclaimer}
          </p>
        </Reveal>

        <div className="mt-24 space-y-32">
          {categories.map((cat, i) => (
            <CategoryBlock key={cat.id || i} category={cat} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Menu;
